import { Directive, ElementRef, Input } from '@angular/core';

@Directive({ selector: '[sm-restrict-width]' })
export class SalonMonsterRestrictWidthDirective {
    constructor(el: ElementRef) {
     el.nativeElement.style.margin = '0 auto';
     el.nativeElement.style['max-width'] = '800px';
    }
}